// Petits utilitaires DOM : échappement, sélection, délégation d’événements, téléchargement.

export const esc = (s: unknown): string =>
  String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c] ?? c);

export function el<T extends HTMLElement = HTMLElement>(root: ParentNode, selector: string): T {
  const e = root.querySelector<T>(selector);
  if (!e) throw new Error('Élément introuvable : ' + selector);
  return e;
}

export function maybe<T extends HTMLElement = HTMLElement>(root: ParentNode, selector: string): T | null {
  return root.querySelector<T>(selector);
}

/** Délégation : `handler` reçoit l’élément qui correspond à `selector`, le plus proche de la cible. */
export function on<K extends keyof HTMLElementEventMap>(
  root: HTMLElement,
  type: K,
  selector: string,
  handler: (ev: HTMLElementEventMap[K], target: HTMLElement) => void,
): void {
  root.addEventListener(type, (ev) => {
    const t = (ev.target as Element | null)?.closest<HTMLElement>(selector);
    if (t && root.contains(t)) handler(ev, t);
  });
}

export function download(name: string, text: string, type: string): void {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 3000);
}

export function fmtClock(ms: number): string {
  return new Intl.DateTimeFormat('fr-FR', { hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(ms);
}

export function fmtShort(ms: number): string {
  return new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }).format(ms);
}
